export const INPUT_BORDER_WIDTH_PX = '1px';

/**
 * Collection of class names inside Input component.
 *
 * These styles basically only mark input component in named way in case you want to override styles in parent
 */
export const InputClassNames = {
  Root: 'hc-input-root',
  Label: 'hc-input-label',
  MainWrapper: 'hc-input-main-wrapper',
  Main: 'hc-input-main',
  Error: 'hc-input-error',
  PasswordToggle: 'hc-input-password-toggle',
};
